/**
 * @generated SignedSource<<163604f4cb8a274483a8d2da6b73ef13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TalentAvailability = "AVAILABLE" | "BOOKED" | "UNAVAILABLE" | "%future added value";
export type TalentRole = "COLORIST" | "DIRECTOR" | "DRONE_PILOT" | "EDITOR" | "PHOTOGRAPHER" | "PRODUCER" | "SOUND_ENGINEER" | "VIDEOGRAPHER" | "%future added value";
export type OpsTalentPageQuery$variables = Record<PropertyKey, never>;
export type OpsTalentPageQuery$data = {
  readonly talentProfiles: ReadonlyArray<{
    readonly availability: TalentAvailability;
    readonly dayRate: any | null | undefined;
    readonly featured: boolean;
    readonly hourRate: any | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly position: number;
    readonly published: boolean;
    readonly roles: ReadonlyArray<TalentRole>;
    readonly skills: ReadonlyArray<string>;
    readonly slug: string;
    readonly updatedAt: any;
  }>;
};
export type OpsTalentPageQuery = {
  response: OpsTalentPageQuery$data;
  variables: OpsTalentPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TalentProfile",
    "kind": "LinkedField",
    "name": "talentProfiles",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roles",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dayRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availability",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "published",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "featured",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "position",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsTalentPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OpsTalentPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ac913cb30928a8b248557dd5382e4d38",
    "id": null,
    "metadata": {},
    "name": "OpsTalentPageQuery",
    "operationKind": "query",
    "text": "query OpsTalentPageQuery {\n  talentProfiles {\n    id\n    name\n    slug\n    roles\n    skills\n    dayRate\n    hourRate\n    availability\n    published\n    featured\n    position\n    updatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "c92d29e780c2484a619547ddc085069d";

export default node;
